// extracted by mini-css-extract-plugin
export var actionButton = "_5m-1";
export var actionButtons = "_5m-2";
export var actions = "_5m-0";
export var aiUnread = "_5m-10";
export var alignCenter = "_5m-h";
export var backWrapper = "_5m-3";
export var cellContainer = "_5m-4";
export var checkboxContainer = "_5m-5";
export var contentContainer = "_5m-6";
export var contentHeader = "_5m-8";
export var conversationsTableWrapper = "_5m-s";
export var draftReplyBadgeContainer = "_5m-m";
export var dropdownItem = "_5m-b";
export var dropdownItemsContainer = "_5m-a";
export var dropdownTitle = "_5m-c";
export var errorIcon = "_5m-7";
export var filter = "_5m-d";
export var gray = "_5m-i";
export var headerActionButtons = "_5m-e";
export var headerCheckboxContainer = "_5m-f";
export var icon = "_5m-j";
export var menuContainer = "_5m-k";
export var noMoreTicketsIcon = "_5m-12";
export var noMoreTicketsSubText = "_5m-13";
export var oneLine = "_5m-l";
export var optionsButton = "_5m-n";
export var plus = "_5m-o";
export var portalButtonsWrapper = "_5m-g";
export var red = "_5m-p";
export var scrolledTop = "_5m-9";
export var search = "_5m-q";
export var selectedConversationsCount = "_5m-r";
export var spinner = "_5m-t";
export var strong = "_5m-u";
export var summaryCell = "_5m-v";
export var tableContainer = "_5m-11";
export var tagContainer = "_5m-w";
export var threeDots = "_5m-x";
export var twoLines = "_5m-y";
export var unread = "_5m-z";